import { Component } from 'react';
import service from '../../core/service';
import { numberWithCommas, toFarsiNumber } from '../../core/utils';

interface IProps {
  dispatch?: any,
  userData?: any;
}
interface IState {
  active?: number;
  loading?: boolean;
  data?: any
  options?: any,
  dashboardData?: any;
  chartData:any;
}

export class dashboardController extends Component<IProps, IState> {
  state: IState = {
    active: 1,
    loading: false,
    data: {
      labels: [],
      family: "Peyda",
      datasets: [
        // {

        //   label: "صندوق سرمایه گذاری هامرز",
        //   data: [],
        //   fill: {

        //   },
        //   borderColor: "#00AA5B",
        // },
        // {

        //   data: [],
        //   label: "صندوق دوم سرمایه گذاری هامرز",
        //   // fill: false,
        //   borderColor: "#155a9e",
        //   fill: {

        //   },
          // backgroundColor:"gradient"
        // }

      ]

    },
    options: {
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0.5,
        },
      },
      plugins: {

        // tooltips: {
        //   // callbacks: {
        //   //   title: function(tooltipItem:any, data:any) {
        //   //     return data['labels'][tooltipItem[0]['index']];
        //   //   },
        //   //   label: function(tooltipItem:any, data:any) {
        //   //     return data['datasets'][0]['data'][tooltipItem['index']];
        //   //   },
        //   //   afterLabel: function(tooltipItem:any, data:any) {
        //   //     var dataset = data['datasets'][0];
        //   //     var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
        //   //     return '(' + percent + '%)';
        //   //   }
        //   // },
        //   backgroundColor: '#FFF',
        //   titleFontSize: 16,
        //   titleFontColor: '#0066ff',
        //   bodyFontColor: '#000',
        //   bodyFontSize: 14,
        //   displayColors: false
        // },
        tooltip: {
          backgroundColor: '#ffffff',
          titleFontSize: 16,
          boxHeight: "138px",
          bodyFontColor: '#000000',
          titleFontColor: '#000000',
          titleColor: '#000000',
          bodyFontSize: 14,
          bodyColor: "#000000",
          displayColors: false,
          borderColor: 'rgba(0, 0, 0, 0)',
          textAlign: "right",

          bodyFont: {
            family: "Peyda",

          },
          titleFont: {
            family: "Peyda",

          },
          rtl: true,

          callbacks: {
            // backgroundC
            // borderColor: 'rgba(0, 0, 0, 0)',
            // titleFontSize: 16,
            // titleFontColor: '#0066ff',
            // bodyFontColor: '#000',
            // bodyFontSize: 14,
            // displayColors: false,

            labelColor: function () {
              return {
                borderColor: 'red',
                backgroundColor: 'blue',
                borderWidth: 2,
                borderDash: [2, 2],
                borderRadius: 2,
              };
            },
            labelTextColor: function () {
              // return '#00AA5B';
            },

            title: function (context: any) {
              let title = context[0]?.dataset?.label;


              // if (context[0]?.parsed?.x !== null) {
              //     title += toFarsiNumber(numberWithCommas(context[0]?.parsed?.x));
              // }
              return title;
            },
            label: function (context: any) {


              // let label = context.dataset.label || '';
              let label = '';

              if (label) {
                label += '';
              }
              if (context?.parsed?.y !== null) {
                label += `  ${toFarsiNumber(numberWithCommas(context?.parsed?.y))} ریال`;
              }
              return label;
            },
          }
        },
        legend: {
          display: false,
          font: {
            family: "Peyda",
            lineHeight: 2,
            useBorderRadius: true,
            borderRadius: 20,

          },
        }
      },
      scales: {
        // to remove the labels
        x: {
          ticks: {
            font: {
              family: "Peyda",
              weight: 800,
            },
          },
          // to remove the x-axis grid
          grid: {
            drawBorder: false,
            display: false,
          },
        },
        // to remove the y-axis labels
        y: {
          ticks: {
            beginAtZero: true,
            callback: function (value: any) {
              return `${toFarsiNumber(numberWithCommas(value))}  `;
            },

            font: {
              family: "Peyda",
              weight: 800,
            },
          },
          // grid: {
          //   drawBorder: false,
          //   display: false,
          // },
          // to remove the y-axis grid

        },

      }
    },
    dashboardData: [],
    chartData:[]
  };

  getList = async () => {
    const {
    } = this.state;

    this.setState({ loading: true })
    try {
      const response = await service.Dashboard.list();
      if (response) {



        
        var data = [...this.state.chartData];
        for (var i = 0; i < response?.data?.data?.charts?.length; i++) { 
          const obj = {
            label: response?.data?.data?.charts[i]?.title,
            data:response?.data?.data?.charts[i]?.dara.map(
                    (item: any) => {
                      return { x: item.date, y: item.value };
                    }
                  ),
          }
          data.push(obj);
        }
        this.setState({chartData:data})
        this.setState({ dashboardData: response?.data?.data })
        this.setState({
          loading: false,
          data: {
            // labels: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "ابان", "اذر", "دی", "بهمن", "اسفند"],
            family: "Peyda",


            datasets: this.state.chartData 
            // [

            //   {
            //     label: marketDataList?.market_title,
            //     data: marketDataList?.market_data.map(
            //       (item: any) => {
            //         return { x: item.date, y: item.rate };
            //       }
            //     ),
            //   },




              // {

              //   label:  response?.data?.data?.title,
              //   data: x,
              //   fill: {

              //   },
              //   borderColor: "#00AA5B",
              // },
              // {

              //   data: y,
              //   label: 'صندوق دوم سرمایه گذاری هامرز',
              //   // fill: false,
              //   borderColor: "#155a9e",
              //   fill: {

              //   },
              //   // backgroundColor:"gradient"
              // }

            // ]

          },


        })



        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };

}
export default dashboardController;
